import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import Loading from '../common/Loading.js';
import ErrorMessage from '../common/ErrorMessage.js';

class BuyMe extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.added = false;
        this.linksAvailable = this.linksAvailable.bind(this);
        this.getUrls = this.getUrls.bind(this);
        this.getITunesUrl = this.getITunesUrl.bind(this);
        this.getAmazonUrl = this.getAmazonUrl.bind(this);
        this.getBandCampUrl = this.getBandCampUrl.bind(this);
        this.getCDBabyUrl = this.getCDBabyUrl.bind(this);
        this.getNoiseTradeUrl = this.getNoiseTradeUrl.bind(this);
        this.getOtherUrls = this.getOtherUrls.bind(this);
     }

    componentDidMount() {  
        if((!this.props.artist.BuyOptions && !this.props.artist.BuyOptionsStatus) || this.props.artist.BuyOptionsStatus === 'FAILED') {
            this.props.actions.getBuyOptions(this.props.artist.Username);
        }
    }

    linksAvailable() {
        const artist = this.props.artist;
        return artist.BuyOptions && (artist.BuyOptions.ITunesUrl || artist.BuyOptions.AmazonUrl || artist.BuyOptions.BandCampUrl || artist.BuyOptions.CDBabyUrl || artist.BuyOptions.NoiseTradeUrl || (artist.BuyOptions.OtherUrls && artist.BuyOptions.OtherUrls.length));
    }

    getUrls () {
        let urls = [];
        const iTunesUrl = this.getITunesUrl();
        if(iTunesUrl != null) {
            urls.push(iTunesUrl);
        }
        const amazonUrl = this.getAmazonUrl();
        if(amazonUrl != null) {
            urls.push(amazonUrl);
        }
        const bandCampUrl = this.getBandCampUrl();
        if(bandCampUrl != null) {
            urls.push(bandCampUrl);
        }
        const cdBabyUrl = this.getCDBabyUrl();
        if(cdBabyUrl != null) {
            urls.push(cdBabyUrl);
        }
        const noiseTradeUrl = this.getNoiseTradeUrl();
        if(noiseTradeUrl != null) {
            urls.push(noiseTradeUrl);
        }
        const otherUrls = this.getOtherUrls();
        if(otherUrls != null) {
            urls.push(otherUrls);
        }
        return urls;
    }

    getITunesUrl() {
        const artist = this.props.artist;
        if(artist.BuyOptions.ITunesUrl) {
            this.added = true;
            return (<div id="iTunes" key="iTunes" style={{paddingBottom:'30px'}}>
                <a href={artist.BuyOptions.ITunesUrl} target="_blank" style={{color:'#333'}} rel="nofollow">
                    <p>
                        <img src={require('../../images/ituneslogo.png')} style={{maxWidth: 160, maxHeight: 40}} />
                    </p>
                    <p>Buy my tracks on iTunes &#8594;</p>
                </a>
            </div>);            
        }
        else {
            return null;
        }
    }

    getAmazonUrl() {
        const artist = this.props.artist;
        if (artist.BuyOptions.AmazonUrl) {
            this.added = true;
            return (<div id="Amazon" key="Amazon" style={{paddingBottom:'30px'}}>
                <a href={artist.BuyOptions.AmazonUrl} target="_blank" style={{color:'#333'}} rel="nofollow">
                    <p>
                        <img src={require('../../images/amazonlogo.jpg')} style={{maxWidth: 160, maxHeight: 40}} />
                    </p>
                    <p>Buy my tracks on Amazon &#8594;</p>
                </a>
            </div>);
        }
        else {
            return null;
        }
    }

    getBandCampUrl() {
        const artist = this.props.artist;
        if(artist.BuyOptions.BandCampUrl) {
            this.added = true;
            return (<div id="bandCamp" key="bandCamp" style={{paddingBottom:'30px'}}>
                <a href={artist.BuyOptions.BandCampUrl} target="_blank" style={{color:'#333'}} rel="nofollow">
                    <p>
                    <img src={require('../../images/bandcamplogo.png')} style={{maxWidth: 160, maxHeight: 40}} />
                    </p>
                    <p>Buy my tracks on Band Camp &#8594;</p>
                </a>
            </div>);
        }
        else {
            return null;
        }
    }

    getCDBabyUrl() {
        const artist = this.props.artist;
        if(artist.BuyOptions.CDBabyUrl) {
            this.added = true;
            return (<div id="cdBaby" key="cdBaby" style={{paddingBottom:'30px'}}>
                <a href={artist.BuyOptions.CDBabyUrl} target="_blank" style={{color:'#333'}} rel="nofollow">
                    <p>
                        <img src={require('../../images/cdbabylogo.png')} style={{maxWidth: 160, maxHeight: 40}} />
                    </p>
                    <p>Buy my tracks on cdbaby &#8594;</p>
                </a>
            </div>);
        }
    }

    getNoiseTradeUrl() {
        const artist = this.props.artist;
        if(artist.BuyOptions.NoiseTradeUrl) {
            this.added = true;
            return (<div id="noiseTrade" key="noiseTrade" style={{paddingBottom:'30px'}}>
                <a href={artist.BuyOptions.NoiseTradeUrl} target="_blank" style={{color:'#333'}} rel="nofollow">
                    <p>
                    <img src={require('../../images/noisetradelogo.png')} style={{maxWidth: 160, maxHeight: 40}} />
                    </p>
                    <p>Buy my tracks on Noise Trade &#8594;</p>
                </a>
            </div>);        
        }
    }

    getOtherUrls() {
        const artist = this.props.artist;
        if(artist.BuyOptions.OtherUrls && artist.BuyOptions.OtherUrls.length > 0) {
            return (<div id="other" key="other">
                {this.added ?                    
                    <span><strong>OTHER</strong></span>
                :
                    <span><strong>Buy my tracks at:</strong></span>                    
                }
                <br />
                {artist.BuyOptions.OtherUrls.map((otherUrl, index) => {
                    return <a key={index} href={otherUrl} target="_blank" style={{color:'#333'}} rel="nofollow">{otherUrl}</a>;
                })}
            </div>);
        }
        else {
            return null;
        }
    }

    render() {
        const artist = this.props.artist;
        const actions = this.props.actions;
        return (
            artist.BuyOptionsStatus === 'FAILED' ?
                <ErrorMessage error="Sorry, something went wrong! Unable to load purchase options." />
                :
                <div>
                    {this.linksAvailable() ?
                        this.getUrls()               
                    :
                        (artist.BuyOptionsStatus === 'LOADING' ?
                        <Loading /> : <p className="biotext">No buy options available at the moment</p>)                    
                    }
                </div>
        );
    }
}

BuyMe.propTypes = {
    artist: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired
};

export default BuyMe;